import { useMemo } from "react";
import { useUserResources } from "@dreebit-registry/vsm-microservice-components";
import {
    ContaminationDeclarationAccess,
    getContaminationDeclarationAccess,
} from "../utils/contaminationDeclaration/resources";

/** Create / update permission for declarations of contamination, read from the JWT resources. */
export const useContaminationDeclarationAccess = (): ContaminationDeclarationAccess => {
    const resources = useUserResources();
    return useMemo(() => getContaminationDeclarationAccess(resources), [resources]);
};
